import { addCommas } from '@/utils/odds-utils';
import { Box, matchEquals } from '@nf/utils-common/fpw/monadic';
interface DateTimeFormatOptions {
	timeZone: string
};
const getSingleMatchRedirectUrl = ({
	sportId,
	marketType,
	leagueId,
	matchId
}: {
	sportId: number;
	marketType: string;
	leagueId: number;
	matchId: number;
}) => {
	const singleMatchHref = matchEquals(marketType)
		.on('l', () => `/live/${sportId}/${leagueId}/${matchId}`)
		.otherwise(() => `/sports/${sportId}/${marketType}/${leagueId}/${matchId}`);
	return singleMatchHref;
}

const getTaiwanTimetoLocalTime = (dateString: string) => {
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const options: DateTimeFormatOptions = {
		timeZone: userTimeZone,
	};

	const taiwanTime = new Date(`${dateString}+08:00`);
	const localTime = taiwanTime.toLocaleString('en-US', options);

	return localTime;
}

const getServerTimeToLocalDateTime = (dateString?: string) => {
	if (!dateString) {
		return dateString;
	}

	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const options: DateTimeFormatOptions = {
		timeZone: userTimeZone,
	};

	const ServerTime = new Date(`${dateString}-04:00`);
	const localTime = ServerTime.toLocaleString('en-US', options);

	return localTime;
}

const getDisplayPrice = (price: number, UserCurrency: string = '') => Box(price)
	.map(Math.floor)
	.map((price: number) => price.toString())
	.map(addCommas)
	.fold((price: string) => `${UserCurrency ? `${UserCurrency} ` : `${getDefaultCurrencyName()} `}${price}`);

const getDefaultCurrencyId = () => 3;

const getDefaultCurrencyName = () => 'USD';

const getOpeningEndDate = () => {
	const nowDate = new Date();
	const currentDateTime = `${nowDate.getFullYear()}-${nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1}-${nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()}` + 'T' + 
	`${nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()}:${nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()}:${nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()}`;
	const dateTime = new Date(`${getTaiwanTimetoLocalTime(currentDateTime)}`);
	const year = dateTime.getFullYear();
	const month = (dateTime.getMonth() + 1) < 10 ? '0' + (dateTime.getMonth() + 1) : dateTime.getMonth() + 1;
	const date = (dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate());
	const thisYearStartMonth = '12';
	const thisYearStartDate = '14';
	const nextYearEndMonth = '06';
	const nextYearEndDate = '02';
	
	if (year == 2024 && month < thisYearStartMonth) {
		return year + `/${thisYearStartMonth}/${thisYearStartDate}`;
	} else if (year == 2024 && month == thisYearStartMonth) {
		if (date >= thisYearStartDate) {
			return year + '/' + month + '/' + date;
		} else {
			return year + `/${thisYearStartMonth}/${thisYearStartDate}`;
		}
	} else {
		if (year == 2025) {
			const currentDate = new Date(year, parseInt(month.toString()) - 1, parseInt(date.toString()));
			const endDate = new Date(2025, 5, 2);
			
			if (currentDate <= endDate) {
				return year + '/' + month + '/' + date;
			} else {
				return year + `/${nextYearEndMonth}/${nextYearEndDate}`;
			}
		} else {
			return year + `/${nextYearEndMonth}/${nextYearEndDate}`;
		}
	}
}

export const promotionService = {
	getSingleMatchRedirectUrl,
	getTaiwanTimetoLocalTime,
	getServerTimeToLocalDateTime,
	getOpeningEndDate,
	getDefaultCurrencyId,
	getDefaultCurrencyName,
	getDisplayPrice
};
